import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-booking-item-loader',
  templateUrl: './booking-item-loader.component.html',
  styleUrls: ['./booking-item-loader.component.scss']
})
export class BookingItemLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
